/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Metrics_Words_UnitInputs */

const en_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`words`)
};

const fr_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mots`)
};

const de_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wörter`)
};

const it_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`parole`)
};

const ru_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`слова`)
};

const es_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`palabras`)
};

const zh_cn2_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字`)
};

const ja_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言葉`)
};

const hi_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्द`)
};

const pt_pt2_event_metrics_words_unit = /** @type {(inputs: Event_Metrics_Words_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`palavras`)
};

/**
* | output |
* | --- |
* | "words" |
*
* @param {Event_Metrics_Words_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_words_unit = /** @type {((inputs?: Event_Metrics_Words_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Words_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_words_unit(inputs)
	if (locale === "de") return de_event_metrics_words_unit(inputs)
	if (locale === "it") return it_event_metrics_words_unit(inputs)
	if (locale === "ru") return ru_event_metrics_words_unit(inputs)
	if (locale === "es") return es_event_metrics_words_unit(inputs)
	if (locale === "zh-CN") return zh_cn2_event_metrics_words_unit(inputs)
	if (locale === "ja") return ja_event_metrics_words_unit(inputs)
	if (locale === "hi") return hi_event_metrics_words_unit(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_words_unit(inputs)
	return en_event_metrics_words_unit(inputs)
});